<script setup lang="ts">
import type { ChatBubbleProps } from "./chat.types";
import { useChatBubble } from "./useChatBubble";

defineOptions({ name: "EChatBubble" });

const props = defineProps<ChatBubbleProps>();
const { classes } = useChatBubble({ props });
</script>

<template>
  <div :class="classes" class="e-chat-bubble" part="bubble">
    <slot />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
